import angular from 'angular';

angular
  .module('processdelay', [])

  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider.state('processdelay', {
        data: {
          authorizedRole: 'USER_BO'
        }
      });
    }
  ]);
